export default "__VITE_ASSET__xSUP$VXF__"